export {
  extendReservationMutation,
  getCapacityOptions,
  getCapacityQueryKey,
  getReservationOptions,
  getReservationQueryKey,
  listReservationsOptions,
  listReservationsQueryKey,
  releaseReservationMutation,
  reserveCapacityMutation,
} from '@/shared/api/__generated__'
